import useSelectedPharmacy from './useSelectedPharmacy';

export type OrganisationFeatureFlag =
  | 'sms_campaigns'
  | 'super_links'
  | 'pgds'
  | 'marketing_material';

export default function useOrganisationFeatureFlag(flag: OrganisationFeatureFlag): boolean {
  const selectedPharmacy = useSelectedPharmacy();
  return selectedPharmacy?.chain?.feature_flags?.[flag] !== false;
}
